import React, { useEffect, useMemo, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { Menu } from 'antd'
import Sider from 'antd/es/layout/Sider'
import logo from '../../assets/images/logo.png'
import { hasPermission } from '../../config-func'
import {
  ApartmentOutlined,
  FileTextOutlined,
  HomeOutlined,
  PieChartOutlined,
  TruckOutlined,
  UserAddOutlined
} from '@ant-design/icons'
import styles from './index.module.scss'

export default function Sidebar({ isCollapsed }) {
  const navigate = useNavigate()
  const [selectedKeys, setSelectedKeys] = useState()
  const [hoverCollapsed, setHoverCollapsed] = useState(null)
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768)
  const [userPermissions, setUserPermissions] = useState([])
  const [userRole, setUserRole] = useState('')

  const localtion = useLocation()

  useEffect(() => {
    // Lấy danh sách quyền từ localStorage hoặc context
    const permissions = JSON.parse(localStorage.getItem('permissions') || '[]')
    const user_role = localStorage.getItem('user_role')
    setUserPermissions(permissions)
    setUserRole(user_role)
  }, [])

  useEffect(() => {
    setSelectedKeys(localtion?.pathname)
  }, [localtion?.pathname])

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768)
    }
    window.addEventListener("resize", handleResize)
    return () => window.removeEventListener("resize", handleResize)
  }, [])

  const isCollapsedMemo = useMemo(() => {
    if (isMobile) return true
    return hoverCollapsed !== null ? hoverCollapsed : isCollapsed
  }, [hoverCollapsed, isCollapsed, isMobile])

  const menuItems = [
    {
      key: '/',
      icon: <HomeOutlined />,
      label: 'Dashboard',
      permission: 'P35' // Quyền Dashboard
    },
    {
      key: '/system-manager',
      icon: <FileTextOutlined />,
      label: 'Quản lý vận hành hệ thống',
      permission: 'P36' // Quyền quản lý vận hành
    },
    {
      key: '/post-management',
      icon: <FileTextOutlined />,
      label: 'Quản lý tin BĐS nội bộ',
      // permission: 'P39' // Quyền quản lý tin nội bộ
      permission: 'P37' // Quyền quản lý tin nội bộ
    },
    {
      key: '/duplicate-post-management',
      icon: <FileTextOutlined />,
      label: 'Quản lý trùng tin BĐS nội bộ',
      // permission: 'P39' // Quyền quản lý tin nội bộ
      permission: 'P76' // Quyền quản lý tin nội bộ
    },
    {
      key: '/request-internal-management',
      icon: <FileTextOutlined />,
      label: 'Quản lý yêu cầu nội bộ',
      permission: 'P38' // Quyền quản lý yêu cầu nội bộ
    },
    {
      key: '/post-community-management',
      icon: <FileTextOutlined />,
      label: 'Quản lý tin cộng đồng',
      permission: 'P39' // Quyền quản lý tin cộng đồng
    },
    // {
    //   key: '/duplicate-post-community-management',
    //   icon: <FileTextOutlined />,
    //   label: 'Quản lý trùng tin cộng đồng',
    //   permission: 'P77' // Quyền quản lý tin cộng đồng
    // },
    {
      key: '/role-management',
      icon: <ApartmentOutlined />,
      label: 'Quản lý Quyền',
      permission: 'P40' // Quyền quản lý quyền
    },
    {
      key: '/department-management',
      icon: <FileTextOutlined />,
      label: 'Quản lý Sàn',
      permission: 'P41' // Quyền quản lý sàn
    },
    {
      key: '/user-management',
      icon: <UserAddOutlined />,
      label: 'Quản lý Tài khoản',
      permission: 'P42' // Quyền quản lý tài khoản
    },
    {
      key: '/project-management',
      icon: <FileTextOutlined />,
      label: 'Quản lý Thư viện dự án',
      permission: 'P43'
    },
    {
      key: '/project-recommend-management',
      icon: <FileTextOutlined />,
      label: 'Quản lý Dự án mở bán',
      permission: 'P44'
    },
    {
      key: '/notification-management',
      icon: <FileTextOutlined />,
      label: 'Quản lý thông báo',
      permission: 'P45'
    },
    {
      key: '/auction-and-view-history',
      icon: <FileTextOutlined />,
      label: 'QL người dùng đấu giá và đăng ký xem nhà',
      permission: 'P49'
    },
    {
      key: '/project-recommend-register',
      icon: <FileTextOutlined />,
      label: 'QL người dùng ĐK tư vấn thông tin dự án và ĐK xem căn hộ mẫu',
      permission: 'P47'
    },
    {
      key: '/recharge-packages-promotions',
      icon: <FileTextOutlined />,
      label: 'Quản lý gói nạp tiền & khuyến mãi',
      permission: 'P51'
    },
    {
      key: '/recharge-packages-promotions-history',
      icon: <FileTextOutlined />,
      label: 'QL nạp tiền & thanh toán',
      permission: 'P52'
    },
    {
      key: '/community-pakage',
      icon: <FileTextOutlined />,
      label: 'QL cấu hình gói gia hạn cộng đồng',
      permission: 'P53'
    },
    {
      key: '/community-pakage-history',
      icon: <FileTextOutlined />,
      label: 'QL lịch sử gia hạn cộng đồng',
      permission: 'P54'
    },
    // {
    //   key: '/configuration-pakage-post',
    //   icon: <FileTextOutlined />,
    //   label: 'QL cấu hình gói tin đăng Web',
    //   permission: 'P55'
    // },
    {
      key: '/history-pakage-post',
      icon: <FileTextOutlined />,
      label: 'QL lịch sử gói tin đăng Web',
      permission: 'P56'
    },
    {
      key: '/manager-post-web',
      icon: <FileTextOutlined />,
      label: 'QL tin đăng trên Web',
      permission: 'P57'
    },
    {
      key: '/manager-request-post-web',
      icon: <FileTextOutlined />,
      label: 'QL yêu cầu trên Web',
      permission: 'P85'
    },
    {
      key: '/manager-payment-gateway',
      icon: <FileTextOutlined />,
      label: 'QL đối soát qua Cổng thanh toán',
      permission: 'P58'
    },
    {
      key: '/manager-footer',
      icon: <FileTextOutlined />,
      label: 'Quản lý footer',
      permission: 'P59'
    },
    {
      key: '/manager-imess',
      icon: <FileTextOutlined />,
      label: 'Quản lý số iMess',
    },
    {
      key: '/manager-slide',
      icon: <FileTextOutlined />,
      label: 'Quản lý Side ảnh và banner',
      permission: 'P61'
    },
    {
      key: '/center-info',
      icon: <FileTextOutlined />,
      label: 'Quản lý thông tin trung tâm',
      permission: 'P62'
    },
    {
      key: '/web-fee-management',
      icon: <FileTextOutlined />,
      label: 'Quản lý thu phí web',
      permission: 'P82'
    },
    {
      key: '/service-management',
      icon: <FileTextOutlined />,
      label: 'Quản lý dịch vụ',
      permission: 'P83'
    },
    {
      key: '/management-recruitment',
      icon: <FileTextOutlined />,
      label: 'Quản lý tuyển dụng',
      permission: 'P78'
    },
    {
      key: '/breaking-news',
      icon: <FileTextOutlined />,
      label: 'Quản lý tin nhanh',
      permission: 'P79'
    },
    {
      key: '/selection-management',
      icon: <FileTextOutlined />,
      label: 'Quản lý selection',
      permission: 'P80'
    },
    {
      key: '/data-customer-management',
      icon: <FileTextOutlined />,
      label: 'DATA dữ liệu khách hàng',
      permission: 'P81'
    },
    {
      key: '/account-web-management',
      icon: <FileTextOutlined />,
      label: 'Quản lý tài khoản web',
      permission: 'P84'
    },
    {
      key: '/management-booking',
      icon: <FileTextOutlined />,
      label: 'Quản lý booking',
      permission: 'P86'
    },
  ]

  // Lọc menu items dựa trên quyền
  const filteredItems = menuItems.filter(item => {
    // Nếu là ADMIN thì hiển thị tất cả menu
    if (userRole === 'ADMIN') {
      return true
    }
    // Nếu không phải ADMIN thì check quyền
    return hasPermission(item.permission, userPermissions)
  })
  return (
    <Sider
      width={265}
      className={styles.wrapper}
      collapsed={isCollapsedMemo}
      onMouseEnter={() => {
        if (isCollapsed) {
          setHoverCollapsed(false)
        }
      }}
      onMouseLeave={() => {
        setHoverCollapsed(null)
      }}
      style={{
        overflow: "auto",
        height: "100vh",
      }}
    >
      <div className="logo p-2 flex items-center justify-center">
        <img src={logo} alt="Logo" style={{ width: 80 }} />
      </div>

      <Menu
        theme="dark"
        mode="inline"
        selectedKeys={[selectedKeys]}
        onClick={(e) => {
          navigate(e.key)
          setSelectedKeys(e.key)
        }}
        defaultSelectedKeys={['1']}
        defaultOpenKeys={['sub1']}
        items={filteredItems}
      />
    </Sider>
  )
}
